import router from './router'
import permissionRouter from './router/permissionRouter'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getStorage } from '@/utils/storage'
import { hasPermission, loadRoleList, getCachedRoleList, shouldSkipRoleList } from '@/utils/permission'
import { COMPANY_SHORT_NAME } from '@/constants'
NProgress.configure({ showSpinner: false })

const whiteList = ['/login', '/reset']

function resolveMenuPath (basePath, routePath) {
  if (!routePath) return basePath || '/'
  if (routePath.charAt(0) === '/') return routePath
  if (!basePath || basePath === '/') return '/' + routePath
  return basePath.replace(/\/$/, '') + '/' + routePath
}

export function getFirstPermissionPath () {
  for (let i = 0; i < permissionRouter.length; i++) {
    const route = permissionRouter[i]
    const parentRoles = (route.meta && route.meta.roles) || []
    if (!hasPermission(parentRoles)) continue
    const children = route.children || []
    for (let j = 0; j < children.length; j++) {
      const child = children[j]
      if (child.hidden) continue
      if (!child.meta || !child.meta.title) continue
      const childRoles = child.meta.roles
      if (childRoles && childRoles.length && !hasPermission(childRoles)) continue
      return resolveMenuPath(route.path, child.path)
    }
  }
  return ''
}

function isRouteAllowed (to) {
  const records = to.matched || []
  for (let i = 0; i < records.length; i++) {
    const roles = records[i].meta && records[i].meta.roles
    if (roles && roles.length && !hasPermission(roles)) return false
  }
  return true
}

async function ensureRoleList () {
  if (getCachedRoleList().length) return
  if (shouldSkipRoleList()) return
  try {
    await loadRoleList()
  } catch (e) {}
}

router.beforeEach(async (to, from, next) => {
  NProgress.start()
  document.title = `${COMPANY_SHORT_NAME}-运营管理后台`
  const hasToken = getStorage('token')

  if (hasToken) {
    await ensureRoleList()
    const homePath = getFirstPermissionPath()
    if (to.path === '/login') {
      if (homePath && homePath !== to.path) {
        next({ path: homePath, replace: true })
      } else {
        next()
      }
      NProgress.done()
      return
    }

    if (!isRouteAllowed(to)) {
      if (homePath && homePath !== to.path) {
        next({ path: homePath, replace: true })
      } else {
        next({ path: '/login', replace: true })
      }
      NProgress.done()
      return
    }

    next()
    NProgress.done()
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next(`/login`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})



// WEBPACK FOOTER //
// ./src/permission.js